<script setup lang="ts">
  import { onUnmounted, provide } from 'vue'
  import { agencyStructureKey } from '@gat-ship/types/injection-keys'
  import { useAgencyStructure } from '../../composables/useAgencyStructure'

  const props = withDefaults(
    defineProps<{
      fetchOnMount?: boolean
      includeInactive?: boolean
    }>(),
    {
      includeInactive: true
    }
  )

  const agencyStructure = useAgencyStructure()

  if (props.fetchOnMount) {
    agencyStructure.fetchAgencyStructure({
      includeInactive: props.includeInactive
    })
  }

  provide(agencyStructureKey, agencyStructure)
  defineExpose(agencyStructure)

  onUnmounted(() => {
    agencyStructure.unsubscribeFromEvents()
  })
</script>

<template>
  <slot />
</template>
